"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DayOfWeekValidator_1 = require("../../../core/model/data-dictionary/validators/DayOfWeekValidator");

var Constraint_1 = require("./Constraint");

var ConstraintTypeEnum_1 = require("./ConstraintTypeEnum");
/**
 * Regular price can be changed only on specific week days,
 * prices must NOT be changed in days contained within this week day restriction.
 *
 * @author Jaroslav Sevcik
 * @author Radek Beran
 */


var WeekDayRestriction =
/*#__PURE__*/
function (_Constraint_1$Constra) {
  _inherits(WeekDayRestriction, _Constraint_1$Constra);

  /**
   * @param days ISO day of week numbers (1: Monday - 7: Sunday, 0 - empty array)
   */
  function WeekDayRestriction(days) {
    var _this;

    _classCallCheck(this, WeekDayRestriction);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WeekDayRestriction).call(this));
    _this.days = days;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WeekDayRestriction, [{
    key: "getType",
    value: function getType() {
      return ConstraintTypeEnum_1.ConstraintTypeEnum.WeekDayRestriction;
    }
  }]);

  return WeekDayRestriction;
}(Constraint_1.Constraint);

exports.WeekDayRestriction = WeekDayRestriction; // tslint:disable-next-line:member-ordering

WeekDayRestriction.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WeekDayRestriction.name);
  return {
    days: builder.listOf(builder.num('days'), new DayOfWeekValidator_1.DayOfWeekValidator())
  };
}();